let observer;
const createSearchTimingObserver = (logger) => (list) => {
    const entries = list.getEntries();
    const createSearchRequest = entries
        .filter((entry) => /graphql\/(flexible)?(hotel|holiday)search(mutation)?$/.exec(entry.name))
        .pop();
    const searchResultsRequest = entries
        .filter((entry) => /graphql\/(hotel|holiday)searchresults$/.exec(entry.name))
        .pop();
    if (createSearchRequest && searchResultsRequest) {
        const searchLeadTime = searchResultsRequest.responseEnd - createSearchRequest.startTime;
        logger(searchLeadTime);
        performance.clearResourceTimings();
    }
};
export function createSearchObserver(logger) {
    const searchTimingObserver = createSearchTimingObserver(logger);
    observer = new PerformanceObserver(searchTimingObserver);
}
export function reportSearchTiming() {
    observer.observe({ type: 'resource', buffered: true });
}
export function disconnectSearchObserver() {
    observer.disconnect();
}
